export default __webpack_public_path__ + "static/parigi-plus-lite-4-bba530e4963fa36f0d73842838c6baff.jpg";